import styled from "styled-components";

export const StyledContainer = styled("div")<{
	border?: boolean;
}>`
	position: relative;
	width: 100%;
	max-width: 1200px;
	margin-right: auto;
	margin-left: auto;
	padding: 0 60px;
	box-sizing: border-box;
	border-top: ${(p) => (p.border ? "1px solid var(--color-border)" : "")};

	@media only screen and (max-width: 1024px) {
		max-width: 100%;
		padding: 0 30px;
	}

	@media only screen and (max-width: 768px) {
		max-width: 100%;
		padding: 0 18px;
	}

	@media only screen and (max-width: 414px) {
		max-width: 100%;
		padding: 0 16px;
	}
`;
